<style>.zoezi-social-media a{
	color: currentColor;
}</style>
<template><div class="zoezi-social-media" :style="{ fontSize: size + 'px' }">
    <a v-if="facebook" :href="facebook" target="_blank"><i class="mdi mdi-facebook"></i></a>
    <a v-if="instagram" :href="instagram" target="_blank"><i class="mdi mdi-instagram"></i></a>
    <a v-if="linkedin" :href="linkedin" target="_blank"><i class="mdi mdi-linkedin"></i></a>
    <a v-if="twitter" :href="twitter" target="_blank"><i class="mdi mdi-twitter"></i></a>
    <a v-if="mail" :href="getmail" target="_blank"><i class="mdi mdi-at"></i></a>
</div></template>
<script>export default {
    props: {
        size: {
            title: 'Ikonstorlek (px)',
            type: Number,
            default: 32,
        },
        facebook: {
            title: 'Facebook (URL)',
            type: String,
            default: '',
        },
        instagram: {
            title: 'Instagram (URL)',
            type: String,
            default: '',
        },
        linkedin: {
            title: 'LinkedIn (URL)',
            type: String,
            default: '',
        },
        twitter: {
            title: 'Twitter (URL)',
            type: String,
            default: '',
        },
        mail: {
            title: 'E-postadress',
            type: String,
            default: '',
        }
    },
    computed: {
    	getmail: function(){
        	return 'mailto:'+this.mail;
        }
    },
    data: () => ({

    }),
    methods: {

    }
}</script>